export default "__VITE_ASSET__982c589e__"